import { render, staticRenderFns } from "./AgentBalanceHistory.vue?vue&type=template&id=564588af&scoped=true"
import script from "./AgentBalanceHistory.vue?vue&type=script&lang=js"
export * from "./AgentBalanceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564588af",
  null
  
)

export default component.exports